module.exports = __webpack_public_path__ + "static/media/text-scale-background.01eedab7.svg";